import { type ElementType, type HTMLAttributes } from 'react';

const variantClass = {
  card: 'glass-surface',
  nav: 'glass-surface-nav',
  modal: 'glass-surface-modal',
  tinted: 'glass-tinted',
} as const;

export interface GlassSurfaceProps extends HTMLAttributes<HTMLElement> {
  variant?: keyof typeof variantClass;
  as?: ElementType;
}

export function GlassSurface({
  variant = 'card',
  as: Component = 'div',
  className = '',
  children,
  ...props
}: GlassSurfaceProps) {
  return (
    <Component className={`${variantClass[variant]} ${className}`} {...props}>
      {children}
    </Component>
  );
}
